import React from 'react';
import { FontIcon } from 'material-ui';
import R from 'ramda';

const minRow = (value = '', charLength) => {
  const numberOfLineBreaks = (value.match(/\n/g) || []).length;
  const rowNum = (value || '').length / (charLength || 70) + numberOfLineBreaks;
  if (rowNum < 5) return 5;
  return Math.floor(rowNum);
};
export default ({ value, onChange, style, charLength, placeholder }) => (
  <div style={R.merge({ padding: '12px 12px 0 12px', overflow: 'auto', minHeight: '120px', border: '1px solid #00BCD4' }, style)}>
    <FontIcon className="tc-icon-email" color="#bfbfbf" style={{ top: '12px' }} />
    <textarea
      placeholder={placeholder || 'Add a note...'}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        float: 'right',
        width: '90%',
        marginRight: '5%',
        marginBottom: '2px',
        fontSize: '14px',
        lineHeight: '18px',
        border: 'none',
        resize: 'none',
        overflow: 'hidden',
      }}
      rows={minRow(value, charLength)}
    />
  </div>
);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/message-box.jsx